<div class="main-container ac-table-page">

  <div class="page-header">
    <div class="title">
      <span class="title-text">Utsav</span>
      <p class="small-title">
        {{ canManage
          ? 'View and manage utsavs, dates, and accommodation inventory.'
          : 'View utsav dates and accommodation information.' }}
      </p>
    </div>

    @if(canManage){
    <div class="header-actions">
      <button type="button" class="ac-primary-btn" [disabled]="isLoading" (click)="openForm(null)">
        Add Utsav
      </button>
    </div>
    }
  </div>

  <div class="table-container ac-table-region" role="region" aria-label="Branch utsavs" tabindex="0">
    <table class="table ac-responsive-table ac-sortable-table" matSort [matSortDisableClear]="true" (matSortChange)="sortUtsavs($event)">
      <thead class="table-head">
        <tr>
          <th scope="col" mat-sort-header="name" data-mobile-sort>Name</th>
          <th scope="col" mat-sort-header="utsavCode">Code</th>
          <th scope="col" mat-sort-header="utsavStartDate" data-mobile-sort>Start</th>
          <th scope="col" mat-sort-header="utsavEndDate">End</th>
          <th scope="col" mat-sort-header="accommodationStartDate">Accommodation From</th>
          <th scope="col" mat-sort-header="accommodationEndDate">Accommodation To</th>
          <th scope="col" mat-sort-header="status" data-mobile-sort>Status</th>
          @if(canManage){ <th scope="col" class="ac-actions-column">Actions</th> }
        </tr>
      </thead>

      <tbody class="table-body">
        @for(utsav of utsavs; track utsav.utsavId){
        <tr>
          <td data-label="Name">{{ utsav.name }}</td>
          <td data-label="Code">{{ utsav.utsavCode || '-' }}</td>
          <td data-label="Start">{{ utsav.utsavStartDate || '-' }}</td>
          <td data-label="End">{{ utsav.utsavEndDate || '-' }}</td>
          <td data-label="Accommodation From">{{ utsav.accommodationStartDate || '-' }}</td>
          <td data-label="Accommodation To">{{ utsav.accommodationEndDate || '-' }}</td>
          <td data-label="Status">{{ isActive(utsav.status) ? 'Active' : 'Inactive' }}</td>
          @if(canManage){
          <td class="actions-cell ac-actions-column" data-label="Actions">
            <div class="row-actions">
              <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading" (click)="openForm(utsav)">Edit</button>
              <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading" (click)="manage(utsav)">Manage</button>
              @if(isActive(utsav.status)){
              <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading" (click)="deactivate(utsav)">
                Deactivate
              </button>
              } @else if(canActivate){
              <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading" (click)="activate(utsav)">
                Activate
              </button>
              }
            </div>
          </td>
          }
        </tr>
        }

        @if(!isLoading && utsavs.length === 0){
        <tr class="ac-empty-table-row">
          <td [attr.colspan]="canManage ? 8 : 7" class="empty-row">No Records Found</td>
        </tr>
        }
      </tbody>
    </table>
  </div>

</div>

<app-loader [isLoading]="isLoading"></app-loader>
